// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"445aef1c","236":"8d4193e7","261":"a88a68c9","373":"2cbc19cf","388":"b3acb615","428":"e3b0dbce","491":"1c0577f5","583":"5d1b7897","648":"825d1c8d","662":"e5beb5b9","712":"0866f982","793":"badf159c","931":"63c02e89"}[chunkId] + ".chunk.js";
};